import Auth from '@aws-amplify/auth'

// const config = require('../config-dev-omi-local.json') // おみとらローカル開発環境設定ファイル
// const config = require('../config-dev-local.json') // ローカル開発環境設定ファイル
// const config = require('../config-dev-cloud9.json') // cloud9開発環境用
// const config = require('../config-dev.json') // 開発環境設定ファイル
// const config = require('../config-stg') // ステージング環境設定ファイル
const config = require('../config') // 本番環境設定ファイル

export default {
  data () {
    const storagekey_loginUserPosition = "tplats_loginUserPosition"
    return {
      config: config,
      storagekey_loginUserPosition,
    }
  },
  methods: {
    getIdTokenFromStorage: function(){
      var mainKey = 'CognitoIdentityServiceProvider.' + this.config.userPoolWebClientId
      const subKey = localStorage.getItem(mainKey + '.LastAuthUser')
      var key = mainKey + '.' + subKey + '.idToken'
      return localStorage.getItem(key)
    },
    getAccessTokenFromStorage: function(){
      var mainKey = 'CognitoIdentityServiceProvider.' + this.config.userPoolWebClientId
      const subKey = localStorage.getItem(mainKey + '.LastAuthUser')
      var key = mainKey + '.' + subKey + '.accessToken'
      return localStorage.getItem(key)
    },
    getURLParameter (name, source) {
      return decodeURIComponent((new RegExp('[?|&amp;|#]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(source) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },

    setTokenToStorage () {
      var accessToken = this.getURLParameter('access_token', location.hash)
      // すでにトークンがある場合は処理終了する
      if (accessToken == null || accessToken =='') {
        accessToken = this.getAccessTokenFromStorage()
        this.getAccount()
        if (accessToken != null && accessToken !='') {
          return
        }
      }
      
      // access_tokenがない場合はログインへ
      if (accessToken == null || accessToken =='') {
        var urlParams = new URLSearchParams(window.location.search);
        var myParam = urlParams.get('d');
        window.location.href = this.config.cognito_url+'?d='+myParam
      }

      this.getAccount()
    },
    getAccount(){
      Auth.currentAuthenticatedUser({
        bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).then(user => {
      this.account = user.attributes.email
    })
    .catch(err => console.log(err));
    }
  }
}